define('gumbo-js-client-lib/Gumbo',['require','exports','module','jquery','./forms/metaData/MetaDataForm','./forms/gameData/GameForm','./forms/gameData/TeamForm','./forms/gameData/StatusForm','./forms/gameData/DateTimeForm','./forms/gameData/LocationForm','./forms/gameData/WeatherForm','./forms/gameData/PreviewWrapForm','./forms/liveData/LineupsForm','./forms/liveData/OffenseForm','./forms/liveData/DefenseForm','./forms/liveData/PlayForm','./forms/liveData/BoxTeamForm','./forms/liveData/LinescoreForm','./forms/liveData/PlayerForm','./forms/liveData/PitchForm','./forms/liveData/InningForm','extant/extant'],function(require, exports, module) {
	var $ = require("jquery"),
		metadataFormat = require("./forms/metaData/MetaDataForm"),
		gameFormat = require("./forms/gameData/GameForm"),
		teamFormat = require("./forms/gameData/TeamForm"),
		gamestateFormat = require("./forms/gameData/StatusForm"),
		dateTimeFormat = require("./forms/gameData/DateTimeForm"),
		stadiumFormat = require("./forms/gameData/LocationForm"),
		weatherFormat = require("./forms/gameData/WeatherForm"),
		linksFormat = require("./forms/gameData/PreviewWrapForm"),
		lineupsFormat = require("./forms/liveData/LineupsForm"),
		offenseFormat = require("./forms/liveData/OffenseForm"),
		defenseFormat = require("./forms/liveData/DefenseForm"),
		playFormat = require("./forms/liveData/PlayForm"),
		boxTeamFormat = require("./forms/liveData/BoxTeamForm"),
		linescoreFormat = require("./forms/liveData/LinescoreForm"),
		playerFormat = require("./forms/liveData/PlayerForm"),
		pitchFormat = require("./forms/liveData/PitchForm"),
		inningFormat = require("./forms/liveData/InningForm"),
		exists = require("extant/extant");

	var IDPREFIX = "ID",
		playerGroups = ["home", "away", "offense", "defense"],
		pitcherResults = ["win", "loss", "save"],
		gameEventCount = 0;

	function Gumbo() {
		/**
		 * Public Function applyNewData
		 * @param gameData {Object} the JSON formatted Gumbo loaded from the server
		 */
		this.applyNewData = function(newData) {
			// the number of events that have happened before this update, stored
			gameEventCount = (exists(this.metaData, "logicalEvents.length")) ?  this.metaData.logicalEvents.length : 0;

			// apply game data and run through any parsing needed
			if (exists(newData.gameData)) { applyGameData(newData.gameData, this.gameData); }

			// apply live data and run through any parsing needed
			if (exists(newData.liveData)) { applyLiveData(newData.liveData, this.liveData, this.gameData); }

			// apply new meta data and run through the event list to distribute the new material
			if (exists(newData.metaData)) { applyMetaData(newData.metaData, this.metaData); }

			if (!exists(newData, "metaData.logicalEvents" || newData.metaData.logicalEvents.length === 0) && exists(newData, "gameData,liveData")) {
				this.metaData.logicalEvents = [].concat(this.metaData.logicalEvents, "fullUpdate");
			}
		};


		// *************************************** //
		//          < PRIVATE FUNCTIONS >          //
		// *************************************** //
		/**
		 * Private Function applyGameeData
		 * @param updates {Object} the gameData object from the newly loaded data
		 * @param gameObj {Object} the gameData object from the current gumbo object
		 *
		 * adds all new data to the gameData section of the gumbo
		 * activates any pointers that were simply text flags in the JSON
		 */
		function applyGameData(updates, gameObj) {
			$.extend(gameObj, updates);

			// map the 'teamsByID' values
			parseTeams(updates.teams.teamsByID, gameObj);

			if (exists(updates, "status.challenges.challengingTeam")) {
				parseChallengingTeam(updates.status.challenges.challengingTeam, gameObj);
			}
		}

		/**
		 * Private Function applyLiveData
		 * @param updates {Object} the liveData attribute from the newly loaded data
		 * @param liveObj {Object} the liveData attribute from the current gumbo
		 * @param gameObj {Object} the gameData attribute from the current gumbo
		 *
		 * adds all new data to the liveData section of the gumbo
		 * activates any pointers that were simply text flags in the JSON
		 */
		function applyLiveData(updates, liveObj, gameObj) {
			$.extend(liveObj, updates);

			// if the players node exists on the update, it has to be one of the collections so parse those
			if (exists(updates.players)) {
				for (var i = 0, l = playerGroups.length; i < l; i++) {
					var subset = playerGroups[i];
					if (!exists(updates.players[subset])) { continue; }

					parsePlayersObj(updates.players[subset], liveObj.players[subset], liveObj.players.allPlayers, gameObj.teams);
				}
			}

			if (exists(updates, "plays.allPlays")) { parsePlays(updates.plays.allPlays, liveObj); }

			if (exists(updates, "plays.currentPlay")) { parsePlays([updates.plays.currentPlay], liveObj); }

			if (exists(updates, "plays.playsByInning")) {
				var playsByInning = updates.plays.playsByInning;
				for (var i = 0, l = playsByInning.length; i < l; i++) {
					var inning = playsByInning[i];
					parseInningHits(inning.hits.home, liveObj);
					parseInningHits(inning.hits.away, liveObj);
					parsePlaysByInning(inning.top, inning.bottom, i, liveObj);
				}
			}

			if (exists(updates, "plays.scoringPlays")) { parsePlays(updates.plays.scoringPlays, liveObj); }

			if (exists(updates, "linescore.pitchers.win")) { parseFinalPitchers(updates.linescore.pitchers, liveObj)}
		}

		/**
		 * Private function applyMetaData
		 * @param updates {Object} the metadata attribute from the newly loaded data
		 * @param metadataObj {Object} the metadata attribute from the current gumbo
		 */
		function applyMetaData(updates, metadataObj) {
			$.extend(metadataObj, updates);
		}

		/**
		 * Private Function parseTeams
		 * @param teamMapping {Object} the teamsByID attribute node from the loaded game data
		 * @param gameObj {Object} the gameData attribute from the current gumbo obj
		 */
		function parseTeams(teamMapping, gameObj) {
			for (var prop in teamMapping) {
				var id = teamMapping[prop];
				gameObj.teams.teamsByID[prop] = gameObj.teams[id];
			}
		}

		/**
		 * Private Function parseChallengingTeam
		 * @param teamID {String} numerical string of the team id
		 * @param gameObj {Object} the gameData attribute from the current gumbo obj
		 */
		function parseChallengingTeam(teamID, gameObj) {
			gameObj.status.challenges.challengingTeam = gameObj.teams.teamsByID[team];
		}


		/**
		 * Private Function parsePlayers
		 * @param loadedSet {Object} node from the loaded JSON object with player ids as strings
		 * @param liveObjSet {Object} matching node from this object to be populated with pointers to players
		 * @param allPlayers {Object} the players node from the the current gumbo object
		 * @param teams {Object} the teams attribute from the gameData attr of the current gumbo object
		 */
		function parsePlayersObj(loadedSet, liveObjSet, allPlayers, teams) {
			if (!exists(loadedSet)) { return; }
			for (var prop in loadedSet) {
				var id = loadedSet[prop];

				// handling for nested objects
				if (typeof id !== "string") {
					parsePlayersObj(loadedSet[prop], liveObjSet[prop], allPlayers, teams);
					continue;
				} else if (prop === "teamID") {
					// handles the one appearance of a teamID in this list
					liveObjSet[prop] = teams.teamsByID[id];
					continue;
				}

				liveObjSet[prop] = allPlayers[id]
			}
		}

		/**
		 * Private Fucnction parsePlays
		 * @param playsList {Array} the additions to the all plays array
		 */
		function parsePlays(playsList, liveObj) {
			var allPlays = liveObj.plays.allPlays,
				allPlayers = liveObj.players.allPlayers;
			for (var i = 0, l = playsList.length; i < l; i++) {
				var newPlayMatchup = playsList[i].matchup;
				if (!exists(newPlayMatchup, "batter,pitcher")) { continue; }

				newPlayMatchup.batter = allPlayers[IDPREFIX + newPlayMatchup.batter];
				newPlayMatchup.pitcher = allPlayers[IDPREFIX + newPlayMatchup.pitcher];
			}
		}

		function parseInningHits(hits, liveObj){
			hits = hits || [];
			var allPlayers = liveObj.players.allPlayers,
				len = hits.length,
				i=0,
				hit;

			for(; i < len; i++){
				hit = hits[i];
				hit.batter = allPlayers[IDPREFIX + hit.batter] || hit.batter;
				hit.pitcher = allPlayers[IDPREFIX + hit.pitcher] || hit.pitcher;
			}
		}
		/**
		 * Private Function parsePlaysByInning
		 * @param top {Array} list of play indices (re:allPlays)
		 * @param bottom {Array} list of play indices (re:allPlays)
		 * @param liveObj {Object} the liveData attribute from the current gumbo obj
		 *
		 * iterates through the plays by inning to make the string idx a pointer to the actual play obj
		 */
		function parsePlaysByInning(top, bottom, inningNum, liveObj) {
			var inningPlays = [top, bottom],
				allPlays = liveObj.plays.allPlays,
				inning,
				len,
				i = 0,
				j;

			for (; i < 2; i++){
				inning = inningPlays[i];
				len = inning.length;
				for (j = 0; j < len; j++) {
					inning[j] = allPlays[inning[j]];
				}
			}
		}

		/**
		 * Private Function parseScoringPlays
		 * @param scores {Array} list of indices (re:allPlays)
		 * @param liveObj {Object} the liveData attribute from the current gumbo obj
		 *
		 * iterates through the scoring plays to make the string idx a pointer to the actual play obj
		 */
		function parseScoringPlays(scores, liveObj) {
			var allPlays = liveObj.plays.allPlays,
				scoringPlays = liveObj.plays.scoringPlays;

			for (var i = 0, l = scores.length; i < l; i++) {
				var idx = scores[i];
				scoringPlays[i] = allPlays[idx];
			}
		}

		/**
		 * Private Function parseFinalPitchers
		 * @param pitchers {Object}
		 * @param liveObj {Object} the liveData attribute from the current gumbo obj
		 */
		function parseFinalPitchers(pitchers, liveObj) {
			var players = liveObj.players.allPlayers,
				finalPitchers = liveObj.linescore.pitchers;

			for (var i = 0, l = pitcherResults.length; i < l; i++) {
				var standing = pitcherResults[i],
					id = pitchers[standing];
				if (!exists(id)) { continue; }

				finalPitchers[standing] = players[IDPREFIX + id];
			}

		}


		// *************************************** //
		//               < GETTERS >               //
		// *************************************** //
		/**
		 * Public Function getNewGameEvents
		 * @returns {Array} returns the events in the array that have been added since the last update
		 */
		this.getNewGameEvents = function() {
			return [].concat(this.metaData.logicalEvents.slice(gameEventCount));
		};

		/**
		 * Public Function getBasicGameStatus
		 * @returns {Object} returns a stateful collection of base-level info about the game data
		 */
		this.getBasicGameStatus = function() {
			var gamestate = this.gameData.status.abstractGameState;
			var basics =  {
				away: this.gameData.teams.away.teamID,
				home: this.gameData.teams.home.teamID,
				status: this.gameData.status.abstractGameState
			};

			switch (gamestate) {
				case "Preview":
					$.extend(basics, {
						probables: {
							away: null,
							home: null
						}
					});
					break;

				case "Live":
				case "Delayed":
					var play = this.getCurrentPlay();

					$.extend(basics, {
						inningState: this.liveData.linescore.inningState,
						score: {
							away: this.liveData.linescore.away.runs,
							home: this.liveData.linescore.home.runs
						},
						batter: play.matchup.batter.id,
						pitcher: play.matchup.pitcher.id,
						inning: this.liveData.linescore.currentInning,
						inningHalf: this.getHalfInning()
					});

					if (exists(play, "count")) {
						$.extend(basics, {
							count: {
								balls: play.count.balls,
								strikes: play.count.strikes,
								outs: play.count.outs
							}
						})
					}
					break;

				case "Final":
					var pitchers = this.liveData.linescore.pitchers;
					$.extend(basics, {
						pitchers: {
							win: pitchers.win.id,
							loss: pitchers.loss.id,
							save: (exists(pitchers.save)) ? pitchers.save.id : null
						},
						inning: this.liveData.linescore.currentInning
					});
					break;
				case "Other":
					break;
			}

			return basics;
		};

		/**
		 * Public Function getPlayer
		 * @param id {String} numerical string of player id
		 * @returns player object
		 */
		this.getPlayer = function(id) {
			var player = this.liveData.players.allPlayers[IDPREFIX + id] || null;

			return (exists(player)) ? $.extend(true, {}, playerFormat, player) : null;
		};

		/**
		 * Public Function getInning
		 * @param num {int} index of inning, 0-relative
		 * @returns inning object
		 */
		this.getInning = function(num) {
			var inning = this.liveData.linescore[num] || null;

			return (exists(inning)) ? $.extend(true, {}, inningFormat, inning) : null;
		};

		/**
		 * Public Function getHalfInning
		 * @returns {String} binary status of inning top / bottom based on game statefulness
		 */
		this.getHalfInning = function() {
			var innState = this.liveData.linescore.inningState,
				topBott = "top";

			switch(this.gameData.status.abstractGamestate) {
				case "Preview":
					topBott = "Top";
					break;
				case "Final":
					topBott = (innState === "Top") ? "Top" : "Bottom";
					break;
				default:
					topBott = (innState === "Top" || innState === "End") ? "Top" : "Bottom";
					break;
			}

			return topBott;
		};

		/**
		 * Public Function getTeam
		 * @param id {String} id of the team (number only)
		 * @returns {Object} returns team object from the gameData obj
		 */
		this.getTeam = function(id) {
			return this.gameData.teams.teamsByID[IDPREFIX + id];
		};

		/**
		 * Public Function getPlay
		 * @param id {String} numerical string of the id of the play required
		 * @returns formatted play object
		 */
		this.getPlay = function(id) {
			var play = this.liveData.allPlays[IDPREFIX + id] || null;

			return (exists(play)) ? $.extend(true, {}, playFormat, play) : null;
		};

		/**
		 * Public Function getCurrentPlay
		 * @returns {Object} returns current play object
		 */
		this.getCurrentPlay = function() {
			return $.extend(true,{}, playFormat, this.liveData.plays.currentPlay);
		};

		/**
		 * Public Funciton getPitch
		 * @param playId {String} numerical string of the play id the pitch is associated with
		 * @param pitchId {String} numerical string of the pitch id
		 * @param index {int} the index of the pitch in the pitch array on the atbat object
		 * @returns formatted pitch object
		 */
		this.getPitch = function(playId, pitchId, index) {
			var play = this.liveData.allPlays[IDPREFIX + playId] || null,
				pitch = null;

			if (!exists(play, "atbat.pitches")) { return null; }

			if (exists(pitchId)) {
				for (var i = 0, l = play.atbat.pitches.length; i < l; i++) {
					var pitchVal = play.atbat.pitches[i];
					if (pitch.id !== pitchId) { continue; }

					pitch = pitchVal;
					break;
				}
			} else if (exists(index)) {
				pitch = play.atbat.pitches[index];
			}

			return $.extend(true, {}, pitchFormat, pitch);
		}
	}

	// *************************************** //
	//              < PROTOTYPE >              //
	// *************************************** //
	/**
	 * This prototype constructs an empty gumbo object from the format objects required-in above
	 * uses $.extend() as a mixin method to keep from altering the original forms
	 */
	Gumbo.prototype = {
		metaData: $.extend(true, {}, metadataFormat),
		gameData: {
			game: $.extend(true, {}, gameFormat),
			teams: {
				away: $.extend(true,{}, teamFormat),
				home: $.extend(true, {}, teamFormat),
				teamsByID: null
			},
			status: $.extend(true, {}, gamestateFormat),
			datetime: $.extend(true, {}, dateTimeFormat),
			stadium: $.extend(true, {}, stadiumFormat),
			weather: $.extend(true, {}, weatherFormat),
			previewWrap: $.extend(true, {}, linksFormat)
		},
		liveData: {
			players: {
				allPlayers: null,
				away: $.extend(true, {}, lineupsFormat),
				home: $.extend(true, {}, lineupsFormat),
				offense: $.extend(true, {}, offenseFormat),
				defense: $.extend(true, {}, defenseFormat)
			},
			plays: {
				currentPlay: null,
				allPlays: null,
				playsByInning: null,
				scoringPlays: null
			},
			boxscore: {
				gameInfo: null,
				teams: {
					away: $.extend(true, {}, boxTeamFormat),
					home: $.extend(true, {}, boxTeamFormat)
				}
			},
			linescore: $.extend(true, {}, linescoreFormat)
		},
		applyNewData: function() { }
	};

	/**
	 * @returns instantiable gumbo object
	 */
	return Gumbo;
});
